import React from "react";
import classNames from "classnames";
import {FaHeart} from "react-icons/fa6";

// Thay thế HOÀN TOÀN cho HolyFamilySvg (đã dùng xuyên suốt module Gia Phả & Sổ Gia Đình - header,
// nút, empty state...) theo yêu cầu "đồng bộ" - HolyFamilySvg vốn CỐ Ý đơn sắc (currentColor) vì đặt
// trên rất nhiều nền màu khác nhau (trắng trên nền cam, xám ở empty state...). heartColor mặc định
// GIỮ NGUYÊN nguyên tắc đó ('currentColor', không hardcode cam) để mọi chỗ ĐANG DÙNG className
// (text-white, text-color-300, text-family-700...) tiếp tục ăn màu đúng y hệt như trước, không cần
// sửa lại từng chỗ gọi. CHỈ RIÊNG chỗ icon-ô-vuông trong danh sách sidebar (discoveryMapExplorerRouteEntities,
// key 'family_books') mới truyền heartColor="#d97706" tường minh để LUÔN ra đúng cam thương hiệu bất
// kể className truyền vào là gì (khớp cách các icon ghép khác - MassTimeTileIcon/LearnPlayIcon/...
// - đều tự set màu cứng, phớt lờ className ngoài).
export const FamilyIcon = ({
                               size = 32,
                               bgColor = null,           // truyền màu để có nền ô vuông, null = trong suốt (mặc định)
                               heartColor = 'currentColor',
                               heartBackColor,           // màu trái tim phía sau (dưới), mặc định nhạt hơn heartColor
                               dotColor,                 // màu chấm tròn phía trên, mặc định = heartColor
                               className,
                               style,
                               ...props
                           }) => {
    const hasBg = bgColor && bgColor !== 'transparent';

    return (
        <div
            style={{
                width: size,
                height: size,
                backgroundColor: hasBg ? bgColor : 'transparent',
                ...style,
            }}
            className={classNames('relative flex-shrink-0 rounded-lg flex items-center justify-center', className)}
            {...props}>

            {/* Trái tim phía sau (bên phải, thấp hơn / mờ hơn để tạo chiều sâu) */}
            <FaHeart
                size={size * 0.5}
                style={{
                    color: heartBackColor ?? heartColor,
                    opacity: heartBackColor ? 1 : 0.55,
                    position: 'absolute',
                    top: '58%',
                    left: '62%',
                    transform: 'translate(-50%, -50%)',
                }}
            />

            {/* Trái tim phía trước (bên trái, chính) */}
            <FaHeart
                size={size * 0.5}
                style={{
                    color: heartColor,
                    filter: 'drop-shadow(0px 1px 1px rgba(0,0,0,0.2))',
                    position: 'absolute',
                    top: '58%',
                    left: '40%',
                    transform: 'translate(-50%, -50%)',
                }}
            />

            {/* Chấm tròn phía trên, giữa 2 trái tim */}
            <div
                style={{
                    position: 'absolute',
                    top: '18%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: size * 0.16,
                    height: size * 0.16,
                    borderRadius: '9999px',
                    backgroundColor: dotColor ?? heartColor,
                }}
            />
        </div>
    );
};